<template>
  <div class="frontend-style frontend-about-style" :style="{backgroundImage:'url('+Images.Home.banner.bg+')'}">
	  <div class="filter"></div>
  	<div class="history">
		<h1>
			{{$t('About.title')}}
		</h1>
		<div class="split">
			
		</div>
		<p>{{$t('About.copy')}}</p>
		<ul>
			<li v-for="img in Images.Quality.cf">
				<img :src="img" alt="">
			</li>
		</ul>
  	</div>
  </div>
</template>
<script>
	import {mapState} from 'vuex'
	export default{
		name:"about",
		computed:{
			...mapState('frontend',[
				'Images'
			])
		},
		data(){
			return{
				
			}
		}
	}
</script>
